import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import MemberTableFilters from "./MemberTableFilters";
// import ProfileInfo from "./common/ProfileInfo";
import { fetchApiDataDup } from "../../redux/reducers/commonApiSlice";
import { getTrainerMemberReport } from "../../data/ApiEndpoints";
import MemberDetail from "./MemberDetail";
import {
  convertStraight,
  convertTimeHHMMSS,
  convertTimeRangeHHMMSS,
  currentMonthCurrentDate,
  currentMonthStartDate,
} from "../common-data/Converts";
import MemberCheckinLogs from "../pt-trials/common/MemberCheckinLogs";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";

const ABBdetail = ({
  user,
  prevClickValues,
  prevFilters,
  isNotAssignedMembers,
  onClosePrevModal,
  clickedCard,
}) => {
  const dispatch = useDispatch();
  const { dataDup, loadingDup, errorDup } = useSelector(
    (state) => state.common
  );

  const isAdmin = user?.account_type === "admin";
  const isGym = user?.account_type === "gym";
  const isClusterManager = user?.account_type === "cluster_manager";

  const initialClickValues = {
    isModOpen: false,
    userId: "",
    type: "",
    clickedType: "",
    sendableStatsQPs: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);

  const [isPage, setIsPage] = useState(0);
  const iniAllFilters = {
    selectedGym: prevFilters
      ? prevFilters.selectedGym
      : !isAdmin && !isClusterManager
      ? {
          label: isGym ? user?.name : user?.gym_name || "",
          value: user?.gym_id || user?.uid || user?.user_id || "",
        }
      : "",
    selectedStartDate: prevFilters.selectedStartDate || currentMonthStartDate,
    selectedEndDate: prevFilters.selectedEndDate || currentMonthCurrentDate,
    searchString: "",
    lastCheckedIn: "",
    biomaxRegisterStatus: "",
    isAll:
      prevClickValues.clickedType === "biomax_not_registered" ? true : false,
    isOnlyCheckedIn:
      prevClickValues.clickedType === "biomax_not_registered" ? false : true,
    isOnlyNotCheckedIn: false,
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    page: isPage + 1,
    limit: 10,
    gym_id: allFilters.selectedGym?.value || "",
    search: "",
    start_date: allFilters.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
    trainer_id: prevClickValues.userId || "unassigned",
    is_biomax_registered:
      prevClickValues?.clickedType === "biomax_registered"
        ? true
        : prevClickValues?.clickedType === "biomax_not_registered"
        ? false
        : "",
    last_checkin_days_ago: allFilters.lastCheckedIn?.value || "",
    onlyCheckedIn: allFilters.isAll
      ? 1
      : allFilters.isOnlyCheckedIn
      ? 2
      : allFilters.isOnlyNotCheckedIn
      ? 3
      : "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniTbDatas = {
    allData: null,
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onCloseModal = () => {
    setClickValues(initialClickValues);
  };

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
    setFilters(iniFilters);
  };

  function getApiData() {
    dispatch(
      fetchApiDataDup({
        method: "GET",
        endpoint: getTrainerMemberReport,
        payload: {
          filters: filters,
        },
        token: user?.token,
      })
    );
  }

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: prevFilters
  //       ? prevFilters.selectedGym
  //       : !isAdmin
  //       ? {
  //           label: isGym ? user?.name : user?.gym_name || "",
  //           value: user?.gym_id || user?.uid || user?.user_id || "",
  //         }
  //       : "",
  //   }));
  // }, [user?.gym_id]);

  useEffect(() => {
    if (allFilters.isAll) {
      setAllFilters({
        ...allFilters,
        isOnlyCheckedIn: false,
        isOnlyNotCheckedIn: false,
      });
    } else if (allFilters.isOnlyCheckedIn) {
      setAllFilters({
        ...allFilters,
        isAll: false,
        isOnlyNotCheckedIn: false,
      });
    } else if (allFilters.isOnlyNotCheckedIn) {
      setAllFilters({
        ...allFilters,
        isAll: false,
        isOnlyCheckedIn: false,
      });
    }
  }, [
    allFilters.isAll,
    allFilters.isOnlyCheckedIn,
    allFilters.isOnlyNotCheckedIn,
  ]);

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      biomaxRegisterStatus:
        prevClickValues?.clickedType === "biomax_registered"
          ? true
          : prevClickValues?.clickedType === "biomax_not_registered"
          ? false
          : "",
    }));
  }, []);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      gym_id: allFilters.selectedGym?.value || "",
      start_date: allFilters.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
      last_checkin_days_ago: allFilters.lastCheckedIn?.value || "",
      onlyCheckedIn: allFilters.isAll
        ? 1
        : allFilters.isOnlyCheckedIn
        ? 2
        : allFilters.isOnlyNotCheckedIn
        ? 3
        : "",
    }));
  }, [
    isPage,
    allFilters.selectedGym,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
    allFilters.lastCheckedIn,
    allFilters.isAll,
    allFilters.isOnlyCheckedIn,
    allFilters.isOnlyNotCheckedIn,
  ]);

  useEffect(() => {
    if (filters) {
      getApiData();
    }
  }, [filters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (dataDup?.status && dataDup?.data && !errorDup) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: dataDup.data,
        pagination: dataDup?.pagination || [],
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [dataDup, errorDup]);

  const tbColumns = [
    {
      dataField: "user_name",
      text: "member name",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data link"
            style={{
              textDecoration: "underline",
              fontWeight: "700",
              cursor: "pointer",
            }}
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.user_id,
                isModOpen: true,
                type: "member",
                clickedType: "member_logs",
                rowData: {
                  who: "member",
                  name: row?.user_name,
                  mobile: row?.user_mobile,
                  email: row?.user_email,
                  gym_name: row?.gym_name,
                  last_checkin: row?.last_checkin,
                  checkin_time: row?.checkin_time,
                  last_checkin_days_ago: row?.last_checkin_days_ago,
                },
              }))
            }
          >
            {row?.user_name || "NA"}
            <br />
            <small
              style={{
                textTransform: "lowercase",
              }}
            >
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    isNotAssignedMembers && {
      dataField: "gym_name",
      text: "Gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: "Member Last Checkin",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth150 link"
            style={{
              fontWeight: "700",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.user_id,
                isModOpen: true,
                type: "member",
                clickedType: "last_checkin",
                sendableStatsQPs: row?.last_checkin
                  ? `&start_date=${row.last_checkin}&end_date=${row.last_checkin}`
                  : "",
              }))
            }
          >
            {row?.last_checkin ? convertStraight(row.last_checkin) : "-"}
            <br />
            <small>
              {row?.checkin_time ? convertTimeHHMMSS(row.checkin_time) : ""}
              <br />
              {row?.last_checkin_days_ago?.replace(/_/g, " ") || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "total_checkin_days",
      text: "Total Checkin Days",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.total_checkin_days ? row.total_checkin_days : 0}
          </span>
        );
      },
    },
    {
      dataField: "total_workout_started",
      text: "total workout started",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              columnGap: "8px",
            }}
          >
            {row?.total_workout_started || 0}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-stopwatch-fill"
              viewBox="0 0 16 16"
              style={{ color: "#008DDA", width: "25px", height: "25px" }}
            >
              <path d="M6.5 0a.5.5 0 0 0 0 1H7v1.07A7.001 7.001 0 0 0 8 16a7 7 0 0 0 5.29-11.584l.013-.012.354-.354.353.354a.5.5 0 1 0 .707-.707l-1.414-1.415a.5.5 0 1 0-.707.707l.354.354-.354.354-.012.012A6.97 6.97 0 0 0 9 2.071V1h.5a.5.5 0 0 0 0-1zm2 5.6V9a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1 0-1h3V5.6a.5.5 0 1 1 1 0" />
            </svg>
          </span>
        );
      },
    },
    {
      dataField: "total_workout_pending",
      text: "total workout pending",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              columnGap: "8px",
            }}
          >
            {row?.total_workout_pending || 0}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-clock-history"
              viewBox="0 0 16 16"
              style={{ color: "#FB6D48", width: "25px", height: "25px" }}
            >
              <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z" />
              <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z" />
              <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5" />
            </svg>
          </span>
        );
      },
    },
    {
      dataField: "total_workout_completed",
      text: "total workout completed",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              columnGap: "8px",
            }}
          >
            {row?.total_workout_completed || 0}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-check2-circle"
              viewBox="0 0 16 16"
              style={{ color: "#379C00", width: "25px", height: "25px" }}
            >
              <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
              <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
            </svg>
          </span>
        );
      },
    },
    {
      dataField: "avg_rating_by_user",
      text: "Trainer Rating By Member",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              columnGap: "8px",
            }}
          >
            {parseFloat(row?.avg_rating_by_user || 0).toFixed(1) || 0}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-star-fill"
              viewBox="0 0 16 16"
              style={{
                color:
                  parseFloat(row?.avg_rating_by_user || 0) > 3
                    ? "#379C00"
                    : "#D90000",
              }}
            >
              <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
            </svg>
          </span>
        );
      },
    },
    {
      dataField: "trial_status",
      text: "trial status",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.trial_status === "completed" ? (
              <CheckCircleIcon />
            ) : row?.trial_status === "pending" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-clock-history"
                viewBox="0 0 16 16"
                style={{ color: "#FB6D48" }}
              >
                <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z" />
                <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z" />
                <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5" />
              </svg>
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "is_biomax_registered",
      text: "Biomax Register",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_biomax_registered === "true" ? (
              <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Checkin Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer minWidth80vw">
          {!(clickValues.clickedType === "member_logs") && (
            <ModalHeadAndClose
              title={`${clickValues.clickedType?.replace(/_/g, " ")}`}
              onClose={onCloseModal}
            />
          )}

          {clickValues.clickedType === "member_logs" ? (
            <MemberDetail
              user={user}
              prevClickValues={clickValues}
              prevFilters={allFilters}
              trainerInfo={prevClickValues.rowData}
              isNotAssignedMembers={isNotAssignedMembers}
              onClosePrevModal={onCloseModal}
              clickedCard={clickValues.clickedType}
            />
          ) : clickValues.clickedType === "last_checkin" ? (
            <MemberCheckinLogs
              clickValues={clickValues}
              sendableStatsQPs={clickValues.sendableStatsQPs}
              MLCDate={true}
            />
          ) : null}
        </div>
      </Modal>

      {!isNotAssignedMembers ? (
        // <ProfileInfo info={prevClickValues.rowData} />
        <div className="modalHeadAndCloseContainer mod-with-details">
          <div className="user-info">
            <div className="user-details">
              <span className="mod-header">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="33"
                  height="33"
                  viewBox="0 0 33 33"
                  fill="none"
                  onClick={onClosePrevModal}
                >
                  <g id="navigate_before">
                    <path
                      id="icon"
                      d="M19.25 24.75L11 16.5L19.25 8.25L21.175 10.175L14.85 16.5L21.175 22.825L19.25 24.75Z"
                      fill="#1D1B20"
                    />
                  </g>
                </svg>
                {prevClickValues.rowData?.name || "NA"} -{" "}
                {prevClickValues.rowValue || ""}{" "}
                {prevClickValues.clickedType?.replace(/_/g, " ")}
              </span>
              <span className="mod-regular-text underline">
                +91 {prevClickValues.rowData?.mobile || ""}
              </span>
              <span className="mod-regular-text lowercase underline">
                {prevClickValues.rowData?.email || ""}
              </span>
              <span className="mod-light-text">
                {prevClickValues.rowData?.gym_name || ""}
              </span>
              <span className="mod-light-text underline">
                Shift - {prevClickValues.rowData?.shiftTiming || ""}
              </span>
              <span className="mod-light-text underline">
                Last Checked In -{" "}
                {convertStraight(prevClickValues.rowData?.last_checkin) || "-"}{" "}
                {convertTimeRangeHHMMSS(
                  prevClickValues.rowData?.checkin_time
                ) || ""}{" "}
                {prevClickValues.rowData?.last_checkin_days_ago
                  ? `(${prevClickValues.rowData.last_checkin_days_ago?.replace(
                      /_/g,
                      " "
                    )})`
                  : ""}
              </span>
            </div>
          </div>

          <button
            type="button"
            className="closeModalBtn"
            onClick={onClosePrevModal}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-x-lg"
              viewBox="0 0 16 16"
            >
              <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
            </svg>
          </button>
        </div>
      ) : null}

      <MemberTableFilters
        user={user}
        allFilters={allFilters}
        setAllFilters={setAllFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        onClickReset={onClickReset}
        onlyDateRanger={true}
        isChekboxFilters={true}
        clickedCard={clickedCard}
      />

      {loadingDup ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="tab-view-table-container overflowAuto separatedTable">
          <PaymentLinkTable
            tableData={tbDatas.allData}
            tableColumns={tbColumns}
            tablePagination={tbDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        </div>
      )}
    </>
  );
};

export default ABBdetail;
